module.exports = __webpack_public_path__ + "static/media/tod.4abbecb2.png";